<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Sale Payments Report</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/payments-summary">
                    <v-icon left>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <div>
                    <v-row dense>
                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>


                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete name="salesPaymentReportCustomer" dense outlined v-model="record.CustomerId"
                                :items="customers" label="Customer" item-text="Name" item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="3" class="mb-3">
                            <v-btn class="float-right" color="primary" :loading="loader" @click="getReport">
                                <v-icon left>mdi-list-box-outline</v-icon>Generate Report
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-btn text class="float-right">
                                Export to Excel
                                <download-excel :data="reportData" :fields="fields" name="Payments Report">
                                    <v-icon color="green">mdi-file-excel</v-icon>
                                </download-excel>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row dense class="subtitle-2 text--primary">
                        <v-col cols="12" v-if="hideTotals != 'Y'">
                            <span class="totals">Total Payments: {{ TotalAmount | whole-number }}</span>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field label="Search" v-model="search" outlined dense></v-text-field>
                            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="reportData"
                                :search="search">
                                <template v-slot:item.OutAmount="{ item }">
                                    <span>{{ item.OutAmount | whole-number }}</span>
                                </template>

                                <template v-slot:item.Account>
                                    <span>Equity</span>
                                </template>

                                <template v-slot:item.DocDate="{ item }">
                                    <span style="display: inline-block; min-width: 80px; width: 80px">
                                        {{
                                            item.DocDate | date
                                        }}
                                    </span>
                                </template>

                                <!-- action template -->
                                <!-- <template v-slot:item.action="{ item }">
                  <v-btn @click="openDialog(item)" color="editIcon" text icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template> -->
                                <!-- end -->
                            </v-data-table>
                            <!-- snackbar -->
                            <snackbar ref="snackbar"></snackbar>
                        </v-col>
                    </v-row>



                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            record: {},
            pageItems: 2000,
            updatedAccount: null,
            loader: false,
            editItem: {},
            editDialog: false,
            PaymentMode: null,
            accounts: [],
            customers: [],
            search: null,
            menu1: false,
            menu2: false,
            reportData: [],
            TotalAmount: 0,
            returnPayments: [],
            TotalReturns: null,
            headers: [
                { text: "Customer", value: "customer.Name" },
                { text: "Amount", value: "OutAmount" },
                { text: "Payment Mode", value: "Account" },
                { text: "Date", value: "DocDate" },
            ],
            fields: {
                Customer: "customer.Name",
                Amount: "OutAmount",
                Date: "DocDate"
            },
            returnHeaders: [
                { text: "Customer", value: "ocrd" },
                { text: "Amount", value: "SumApplied" },
                { text: "Payment Mode", value: "oact" },
                { text: "Date", value: "DocDate" }
            ]
        };
    },
    computed: {
        hideTotals() {
            return localStorage.getItem("HideDebtorsTotal");
        },
        storeName() {
            return localStorage.getItem("storeName");
        },
        activeStore() {
            return localStorage.getItem("store_id");
        },
        role() {
            return localStorage.getItem("userRole");
        },
        totalPayments() {
            let total = 0;
            if (this.TotalAmount) {
                total = this.TotalAmount.toLocaleString();
            }
            return total;
        }
    },
    methods: {
        openDialog(item) {
            this.editItem = item;
            this.editDialog = true;
        },
        setStartDate(date) {
            this.record.StartDate = date;
        },
        setEndDate(date) {
            this.record.EndDate = date;
        },
        save() {
            if (this.updatedAccount == null) {
                this.$refs.snackbar.show("Please select payment mode!", "red");
            } else {
                const url = "/update/rct1/account";
                const self = this;
                const data = {
                    id: self.editItem.id,
                    account: self.updatedAccount
                };
                this.loader = true;
                this.$store
                    .dispatch("post", { url, data })
                    .then(res => {
                        if (res.ResultCode == 1200) {
                            location.reload();
                        } else {
                            this.$refs.snackbar.show(res.ResultDesc, "red");
                        }
                    })
                    .catch(err => {
                        this.$refs.snackbar.show(err, "red");
                    });
            }
        },
        getAccounts() {
            const self = this;
            this.$store
                .dispatch("get", `/bank-accounts`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.accounts = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getReport() {
            const recordData = this.record;
            const storeId = this.activeStore;

            const data = {
                store_id: storeId,
                AccountId: recordData.PaymentMode,
                SoldBy: null,
                CustomerId: recordData.CustomerId,
                StartDate: recordData.StartDate,
                EndDate: recordData.EndDate
            };
            const url = "/owner-payments-report";
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    console.log(res, " payments response");
                    if (res.ResultCode == 1200) {
                        self.reportData = res.ResponseData.payments;
                        self.TotalAmount = res.ResponseData.TotalAmountPaid;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });

        },
        printDoc() {
            if (this.record.StartDate == null || this.record.EndDate == null) {
                this.$refs.snackbar.show("Please select both dates", "red");
            } else {
                this.print();
            }
        },
        print() { },
        getCustomers() {
            const self = this;
            this.$store
                .dispatch("get", `/customers`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.customers = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {
        this.getAccounts();
        this.getCustomers();
    }
};
</script>

<style lang="scss" scoped></style>